import { DefaultPasswordPolicy, RegexConstants, SettingsConstants } from '../../constants'

const objFunc = () => {
  return {
    vueInstance: null,
    authenticated: false,
    user: null,
    username: null,
    email: '',
    emailVerified: false,
    phone: '',
    phoneVerified: false,
    verified: false,
    password: '', // Should only be used temporarily when attempting to check that the user has verified their email address
    isReferralOnly: undefined,
    signOutInProgress: false,

    savedConfigSettings: false,
    sessionTimeoutStart: null,
    sessionTimeoutIsActive: false,
    sessionTimeoutIsOver: false,
    sessionTimeoutSkip: false,
    sessionTimeoutLimit: SettingsConstants.sessionTimeoutMinutes,
    paymentTimeoutLimit: SettingsConstants.paymentTimeoutLimit,
    refiPaymentTimeoutLimit: SettingsConstants.refiPaymentTimeoutLimit,
    docuSignRedirect: false,
    allowNoSsnRefi: SettingsConstants.allowNoSsnRefi,
    previousPage: '',
    previousProps: {},
    allowManageNotifications: SettingsConstants.allowManageNotifications,
    disbursementMaxPollingAttempts: SettingsConstants.disbursementMaxPollingAttempts,
    serviceAvailable: true,
    servicesConfig: {
      clientId: process.env.VUE_APP_CognitoClientId,
      cognitoUrl: process.env.VUE_APP_CognitoUrl,
      serviceUrl: process.env.VUE_APP_TmxServicesUrl,
      userPoolId: process.env.VUE_APP_CognitoUserPoolId
    },
    internalRedirect: {},
    loanDocUploadFileLimit: SettingsConstants.loanDocUploadFileLimit,
    loanDocUploadFileTypes: SettingsConstants.loanDocUploadFileTypes,
    loanDocUploadInputTypes: SettingsConstants.loanDocUploadFileTypes,
    loanDocAllowedFileTypes: SettingsConstants.loanDocAllowedFileTypes,
    loanDocUploadMaxSize: SettingsConstants.loanDocUploadMaxSize, // MB
    pastDuePhoneDayLimit: SettingsConstants.pastDuePhoneDayLimit, // days
    menuItemVisibility: {},
    deviceDetection: {
      mobileDeviceTest1: RegexConstants.mobileDeviceTest1,
      mobileDeviceTest2: RegexConstants.mobileDeviceTest2
    },
    canUploadTlxeLoanDocuments: false,
    settlementPaymentRetryLimit: SettingsConstants.settlementPaymentRetryLimit,
    canUseDisbursementPolling: false,
    displayReferralBalanceHistory: false,
    displayNonCustomerReferral: false,
    displayRetailReferral: false,
    outForRepoConfig: {},
    forceShowProductSwitchModal: false,
    forceShowRenewalStatement: false,
    checkAddonGps: true,
    checkPaymentGps: true,
    checkRefiGps: true,
    forceAddonGps: true,
    forcePaymentGps: true,
    forceRefiGps: true,
    gpsPosition: {
      latitude: '',
      longitude: ''
    },
    shareTitlemaxEnabled: true,
    canSendVoiceMessages: false,
    fromLegacyNcr: false,

    passwordPolicy: {
      minimumLength: DefaultPasswordPolicy.minimumLength,
      requireLowercase: DefaultPasswordPolicy.requireLowercase,
      requireNoSpaces: DefaultPasswordPolicy.requireNoSpaces,
      requireNumbers: DefaultPasswordPolicy.requireNumbers,
      requireSymbols: DefaultPasswordPolicy.requireSymbols,
      requireUppercase: DefaultPasswordPolicy.requireUppercase
    },

    restrictManualRetry: true,
    restrictedRetryTimeInMins: SettingsConstants.restrictedRetryTimeInMins,
    wrongPasswordRedirectCount: 3,
    bridgePaySettings: {},
    loanOriginateTimeout: SettingsConstants.loanOriginateTimeout,
    postDrawTimeout: SettingsConstants.postDrawTimeout,
    cancelRefiTimeout: SettingsConstants.cancelRefiTimeout,
    debtSoldConfig: {},

    canEditPhone: false,
    canEditEmail: false,

    autoPayStandardPayment: false,
    autoPayRefi: false,
    autoPayReapply: false,

    broadcastMessage: {},
    canUnitasCardCreate: false,
    canRepayCardCreate: false,

    isGuestPayOnlyUser: false, // As determined by textLinkExpiration
    deviceIsTrusted: false, // Determines if user is sent to trusted device pages

    applicationEditMode: false,
    awaitingSignature: undefined,

    disclosuresLinksList: undefined,
    accountCreatedSession: false, // If account was created/verified during this session, navigation changes versus if authenticated via login page

    expressFlowEnabled: false,
    displayDocumentUploadMenuItem: false,
    canMigrateProfileToEmail: false,
    canSkipMigrateProfileToEmail: false,
    updateUsernameInfo: {
      bannerTitle: '',
      bannerText: '',
      instructionText: '',
      skipButtonText: ''
    },
    repayConfig: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
